import { render } from "./DetailNineOClock.vue?vue&type=template&id=38a01e25&scoped=true"
import script from "./DetailNineOClock.vue?vue&type=script&lang=js"
export * from "./DetailNineOClock.vue?vue&type=script&lang=js"

import "./DetailNineOClock.vue?vue&type=style&index=0&id=38a01e25&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-38a01e25"

export default script